module.exports = __webpack_public_path__ + "static/two-roads-above-two-other-roads-851d3e9bf169af87a09c3804d5725b79.jpg";